module.exports = __webpack_public_path__ + "media/images/icons/map-b916e31a0e394ea009f92c0400f1c4a5.svg";